import {
  Search, FileStack, Globe2, HelpCircle, Youtube, MousePointerClick,
  LayoutTemplate, LayoutDashboard, Sparkles, Palette, Circle, FileText,
  Activity, Trophy,
  Users, ShieldCheck, ScrollText, LayoutGrid, Workflow, SlidersHorizontal,
  ListTree, UserCircle, Settings, Library, Package, Handshake, ClipboardList, MessageSquare,
  Plug,
  Share2,
  Gift,
  Inbox,
  ArrowLeftRight,
  Wallet,
  Image as ImageIcon,
  TrendingUp,
} from "lucide-react";
// SCAFFOLD_ICON_IMPORTS

// Maps the backend catalog `icon` string to a lucide component.
export const MENU_ICONS = {
  TrendingUp,
  Search,
  Share2,
  FileStack,
  Globe2,
  HelpCircle,
  Youtube,
  MousePointerClick,
  LayoutTemplate,
  LayoutDashboard,
  Sparkles,
  Palette,
  FileText,
  Activity,
  Trophy,
  Users,
  ShieldCheck,
  ScrollText,
  LayoutGrid,
  Workflow,
  SlidersHorizontal,
  ListTree,
  UserCircle,
  Settings,
  Library,
  Package,
  Handshake,
  ClipboardList,
  MessageSquare,
  Plug,
  Images: ImageIcon,
  Gift,
  Inbox,
  ArrowLeftRight,
  Wallet,
  // SCAFFOLD_ICON_ENTRIES
};

export const iconFor = (name) => MENU_ICONS[name] || Circle;
